import { useEffect } from "react";

const useTitle = (title: string) => {
    useEffect(() => {
        document.title = title || 'Stewart Connect';
    }, [title]);
};

export default useTitle;